import axios from "axios";
import { setAlert } from "./alert";
import { setErrorsList } from "./errors";
import { logout } from "./auth";
import { removeErrors } from "reducers/errors";

import {
  loadingCredentialsList,
  credentialSearchParametersUpdate,
  credentialListUpdated,
  resetCredential,
  credentialError,
  loadingOnCredentialSubmit,
  credentialCreated,
  credentialUpdated,
  credentialDetailsById,
  credentialDeleted,
} from "reducers/credentialReducer";

export const getCredentialsList = (appTokenParams) => async (dispatch) => {
  try {
    const config = {
      "Content-Type": "application/json",
    };

    const query = appTokenParams.query ? appTokenParams.query : "";
    appTokenParams.query = query;
    config.params = appTokenParams;

    dispatch(loadingCredentialsList());
    const res = await axios.get("/api/admin/credentials/list", config);

    dispatch(credentialSearchParametersUpdate(appTokenParams));

    dispatch(credentialListUpdated(res.data.response[0]));
  } catch (err) {
    console.error(err);
    if (err.response.data && err.response.data.tokenStatus === 0) {
      dispatch(logout());
    } else {
      err.response &&
        dispatch(
          credentialError({
            msg: err.response.statusText,
            status: err.response.status,
          })
        );

      dispatch(setAlert(err.response.message, "danger"));
    }
  }
};

export const getCredentialById = (credential_id) => async (dispatch) => {
  dispatch(removeErrors());
  dispatch(loadingOnCredentialSubmit());
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const res = await axios.get(
      `/api/admin/credentials/${credential_id}`,
      config
    );

    dispatch(credentialDetailsById(res.data.response));
    return res.data ? res.data.response : { status: false };
  } catch (err) {
    // console.log(err);
    if (err.response.data && err.response.data.tokenStatus === 0) {
      dispatch(logout());
    } else {
      err.response &&
        dispatch(
          credentialError({
            msg: err.response.statusText,
            status: err.response.status,
          })
        );

      dispatch(setAlert(err.response.message, "danger"));
    }
  }
};

export const createCredential = (formData, navigate) => async (dispatch) => {
  try {
    const config = {
      "Content-Type": "application/json",
    };

    dispatch(loadingOnCredentialSubmit());

    const res = await axios.post("/api/admin/credentials", formData, config);

    if (res.data.status === true) {
      dispatch(credentialCreated(res.data.response));
      dispatch(setAlert("Credential Created.", "success"));
      navigate(`/admin/credentials`);

      return res.data;
    } else {
      const errors = res.data.errors;
      if (errors) {
        dispatch(credentialError());
        dispatch(setAlert(res.data.message, "danger"));

        errors.forEach((error) => {
          dispatch(setErrorsList(error.msg, error.param));
        });
      }
    }
    return res.data ? res.data : { status: false };
  } catch (err) {
    console.error(err);
    if (err.response.data && err.response.data.tokenStatus === 0) {
      dispatch(logout());
    } else {
      err.response &&
        dispatch(
          credentialError({
            msg: err.response.statusText,
            status: err.response.status,
          })
        );

      dispatch(setAlert(err.response.message, "danger"));
    }
  }
};

export const updateCredential =
  (formData, navigate, credential_id) => async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await axios.put(
        `/api/admin/credentials/${credential_id}/edit`,
        formData,
        config
      );

      if (res.data.status === true) {
        await dispatch(credentialUpdated(res.data.response));
        dispatch(setAlert(res.data.message, "success"));
        return res.data ? res.data : { status: false };
      } else {
        const errors = res.data.errors;
        if (errors.length) {
          dispatch(credentialError());
          dispatch(setErrors(errors));
        }
      }
    } catch (err) {
      if (err.response) {
        if (err.response.data && err.response.data.tokenStatus === 0) {
          dispatch(logout());
        } else {
          dispatch(
            credentialError({
              msg: err.response.statusText,
              status: err.response.status,
            })
          );
          dispatch(
            setAlert(
              err.response.data.message || err.response.statusText,
              "danger"
            )
          );
        }
      }
    }
  };

export const deleteCredential = (credential_id) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    await axios.delete(`/api/admin/credentials/${credential_id}`, config);

    dispatch(credentialDeleted(credential_id));
    dispatch(setAlert("Credential deleted", "success"));
  } catch (err) {
    // console.log(err);
    err.response &&
      dispatch(
        credentialError({
          msg: err.response.statusText,
          status: err.response.status,
        })
      );
  }
};

// reset errors
export const removeCredentialErrors = () => async (dispatch) => {
  dispatch(removeErrors());
};

// Dispatch Reset store
export const resetComponentStore = () => async (dispatch) => {
  await dispatch(resetCredential());
};

export const setErrors = (errors) => async (dispatch) => {
  if (errors) {
    dispatch(credentialError());
    dispatch(setAlert("Please correct the following errors", "danger"));
    errors.forEach((error) => {
      dispatch(setErrorsList(error.msg, error.param));
    });
  }
};

export const cancelSave = (navigate) => async (dispatch) => {
  dispatch(removeErrors());
  navigate("/admin/credentials");
};
